import styled from "@emotion/styled"
import { useState } from "react"
import colors from "theme/colors"
import { Container, NewText, ReportsWrapper } from "ui"
import TabPanel from "ui/TabPanel"
import TabTitle from "ui/TabTitle"
import { extractProperty } from "utils/extractProperty"

type Props = {
  data: any
  children: React.ReactNode
}

const StyledTabsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  margin-top: 40px;
  ${(props) => props.theme.breakpoints.up("md")} {
    grid-template-columns: 1fr 1fr;
    gap: 32px;
  }
`

const StyledPageDiv = styled.div`
  padding-top: 32px;
  padding-bottom: 0px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding-top: 80px;
    padding-bottom: 0px;
  }
`

function ImmediateReportsTab({ data, children }: Props) {
  const tabs = extractProperty(data, "tabs")
  const title = extractProperty(data, "title")
  const [value, setValue] = useState(0)

  return (
    <Container>
      <StyledPageDiv>
        {children}
        <NewText
          component={"h1"}
          desktopFontSize={40}
          desktopLineHeight={"44px"}
          desktopFontWeight={400}
          mobileFontSize={32}
          mobileLineHeight={"36px"}
          color={colors.black}
          marginTop={"32px"}
        >
          {title}
        </NewText>
        <TabTitle tabs={tabs} setValue={setValue} value={value} eventName="דיווחים מידיים" />

        {tabs.map((block: any, index: number) => (
          <TabPanel value={value} index={index} key={"panel" + index.toString()}>
            <StyledTabsWrapper>
              {block.properties
                .find((prop: any) => prop.propertyName === "immediateReportsBoks")
                ?.propertyValue?.blocks?.map((data: any, k: number) => {
                  return <ReportsWrapper key={k.toString()} data={data} mainTitle={title} />
                })}
            </StyledTabsWrapper>
          </TabPanel>
        ))}
      </StyledPageDiv>
    </Container>
  )
}

export default ImmediateReportsTab
